import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from "redux-thunk";
import reducer from './reducers';
import {
    POOL_ID,
    CLIENT_ID
} from './constants/auth';
import { Auth } from './utils/auth';
// const store = createStore(
//     reducer,
//     window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
// );

const middleware = [thunk];
const createStoreWithMiddleware = compose(applyMiddleware(...middleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f)(createStore);

export const store = createStoreWithMiddleware(reducer);

if(window.navigator.userAgent.indexOf("cordova")>-1){
	var waitAppVars = setInterval(()=>{
		if(window.is_app){
			startRender();
			clearInterval(waitAppVars);
		}
	},100)
}else{
	startRender()
}

function startRender(){
	const auth = new Auth(POOL_ID, CLIENT_ID);
	sessionStorage.setItem("MSPAuth", auth);
	ReactDOM.render(
	    <Provider store = {store}>
	        <App />
	    </Provider>, 
	    document.getElementById('root'));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
